import { Category } from '../types/Category';

export interface CategoryOption {
    id: number;
    label: string;
}

export function flattenCategories(categories: Category[], depth = 0): CategoryOption[] {
    const options: CategoryOption[] = [];

    for (const category of categories) {
        const prefix = depth > 0 ? `${'— '.repeat(depth)}` : '';
        options.push({
            id: category.id,
            label: `${prefix}${category.name}`,
        });

        if (category.children && category.children.length > 0) {
            options.push(...flattenCategories(category.children, depth + 1));
        }
    }

    return options;
}
